import type { RecordView } from '@kit/sync/types/record-view';
import type { ShoppingItem } from '@/entities/shopping-item/schemas/shopping-item';
import { msg } from '@/shared/i18n/msg';
import { NO_STORE } from '../config/no-store';

type StoreOption = { readonly value: string; readonly label: string; readonly count: number };

/**
 * The store filter: every store on the list, the one with most pending entries first, each with
 * its pending count; "No store" last when some entry has none.
 */
export function storeOptions(list: readonly RecordView<ShoppingItem>[]): StoreOption[] {
  const pending = new Map<string, number>();
  let without = 0;
  for (const { data } of list) {
    const store = data.store?.trim() ?? '';
    const count = data.status === 'pending' ? 1 : 0;
    if (store) pending.set(store, (pending.get(store) ?? 0) + count);
    else without += count;
  }
  const stores = [...pending.entries()]
    .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
    .map(([value, count]) => ({ value, label: value, count }));
  return without > 0 ? [...stores, { value: NO_STORE, label: msg('No store'), count: without }] : stores;
}
